import {
	Directive,
} from '@angular/core';

import styles from './VbUiBtnDanger.module.less';

@Directive({
	selector: '[vbUiBtnDanger]',
	host: {
		'[class]': 'hostClass'
	},
	standalone: false
})
export class VbUiBtnDangerDirective {
	public readonly hostClass: string = `${styles.vbUiBtnDanger}`;
}
